import { Theme } from "@mui/material";

export function useFilterSelectorStyles(isMobile: boolean, isBrowser: boolean, theme: Theme) {
  const selectorContainerStyle = {
    alignItems: isMobile ? "flex-start" : "center",
    direction: isBrowser ? "row" : "column",
    margin: isBrowser ? "" : "auto",
    flexWrap: isBrowser ? "nowrap" : "wrap",
    pt: isMobile ? 2 : 0,
    pl: isMobile ? 1 : 0
  };

  const datePickerContainerStyle = {
    width: isMobile ? "100%" : "auto",
    minWidth: isMobile ? "" : 480
  };

  const datePickerChildStyle = {
    width: isMobile ? "50%" : "auto"
  };

  const typeAndFilterContainerStyle = {
    rowGap: isMobile ? 1 : 0
  };

  const groupFilterBtnStyle = {
    ml: isMobile ? 2 : 0,
    minWidth: isMobile ? 48 : 54,
    height: isMobile ? 44 : 54,
    border: `1px solid ${theme.palette.mode === "dark" ? "rgba(255, 255, 255, 0.12)" : "rgba(0, 0, 0, 0.12)"}`,
    loadingBtnHeight: isMobile ? 44 : 54
  };

  return {
    selectorContainerStyle,
    datePickerContainerStyle,
    datePickerChildStyle,
    typeAndFilterContainerStyle,
    groupFilterBtnStyle
  };
}
